import { render, staticRenderFns } from "./NeredeData.vue?vue&type=template&id=4ef31930&"
import script from "./NeredeData.vue?vue&type=script&lang=js&"
export * from "./NeredeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports